/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const _pagepath = '/information/';

	const dropDownAndTabs = () => {
		if (document.querySelector('.js-news-yearList')) {
			const latest = document.querySelector('.js-news-latest-year').textContent;
			const earliest = document.querySelector('.js-news-earliest-year').textContent;
			const currentPath = location.pathname.replace('index.html', '').replace(/\/$/, '');
			const currentCategory = location.pathname.split('/')[2] || ''; // 現在のカテゴリ（例: "news", "solution"）
			const additionalCategory = location.pathname.split('/')[3] || ''; // 第三階層カテゴリ（例: "news"）
			const yearList = document.querySelector('.js-news-yearList');
	
			// 初期オプション設定
			const initialOption = document.createElement('option');
			initialOption.textContent = '最新';
			initialOption.value = `/information/${currentCategory ? `${currentCategory}/` : ''}`;
			initialOption.selected = location.pathname === initialOption.value;
			yearList.appendChild(initialOption);
	
			// 年度オプション生成関数
			const optionVal = (_num) => {
				return `/information/${_num}/${additionalCategory ? `${additionalCategory}/` : ''}`;
			};
	
			// 年度オプションを追加
			for (let i = latest; i >= earliest; i--) {
				const option = document.createElement('option');
				option.textContent = i.toString();
				option.value = optionVal(i);
				if (location.pathname === option.value) {
					option.selected = true;
				}
				yearList.appendChild(option);
			}
	
			// セレクトボックスの変更イベント
			yearList.addEventListener('change', function () {
				location.href = yearList.value;
			});
		}
	
		const tabMenu = document.querySelector('.tab-menu');
		if (tabMenu) {
			const yearMatch = location.pathname.match(/\/(\d{4})\//);
			const selectedYear = yearMatch ? yearMatch[1] : null;
			const tabLinks = tabMenu.querySelectorAll('a');
	
			// タブリンクのhrefを動的に更新
			tabLinks.forEach(tab => {
				const categoryCode = tab.dataset.tab;
				const baseUrl = selectedYear ? `/information/${selectedYear}` : '/information';
				const newHref = categoryCode ? `${baseUrl}/${categoryCode}/` : `${baseUrl}/`;
				tab.href = newHref;
			});
	
			// タブクリックイベント
			tabLinks.forEach(tab => {
				tab.addEventListener('click', (e) => {
					e.preventDefault();
					location.href = tab.href;
				});
			});
	
			// 現在のURLからアクティブなタブとカテゴリを判定
			const activeCategory = location.pathname.split('/')[3] || '';
			tabLinks.forEach(tab => {
				const tabUrl = new URL(tab.href, location.origin).href;
				if (location.href === tabUrl) {
					tab.classList.add('active'); // タブをアクティブ化
				} else {
					tab.classList.remove('active'); // アクティブ状態を解除
				}
			});
	
			// タブ内容のアクティブ状態を設定
			const tabContents = document.querySelectorAll('.tab-content');
			tabContents.forEach(content => {
				if (content.id === activeCategory) {
					content.classList.add('is-active'); // コンテンツをアクティブ化
				} else {
					content.classList.remove('is-active'); // アクティブ状態を解除
				}
			});
	
			if (!location.pathname.split('/')[3]) {
				const defaultTab = document.querySelector('a[data-tab="all"]');
				const defaultContent = document.querySelector('#all');
				if (defaultTab) defaultTab.classList.add('active');
				if (defaultContent) defaultContent.classList.add('is-active');
			}
		}
	};
	
	const pickupSlide = () => {
		const pickupSlider = document.querySelector(".mod-pickupSlide");
		if (pickupSlider) {
			const slideItems = pickupSlider.querySelectorAll(".splide__slide");
	
			const splide = new Splide(".mod-pickupSlide.splide", {
				type: "loop",
				perPage: 1,
				autoplay: false,
				interval: 5000,
				speed: 500,
				arrows: slideItems.length > 1, // スライドが1つなら矢印を非表示
				pagination: true,
				paginationKeyboard: true,
			}).mount();
		}
	};

	const introductionSlide = () => {
		const introductionSlider = document.querySelector(".mod-introductionSlide");
		if (introductionSlider) {
			const slideItems = introductionSlider.querySelectorAll(".splide__slide");
	
			const splide = new Splide(".mod-introductionSlide.splide", {
				type: "loop",
				perPage: 1,
				autoplay: false,
				interval: 5000,
				speed: 500,
				arrows: slideItems.length > 1, // スライドが1つなら矢印を非表示
				pagination: true,
				paginationKeyboard: true,
			}).mount();
		}
	};

	const pickupCatInsert = () => {
		const getJSONfiles = () => '/ajax/news/list.json';
	
		const insertTags = (data) => {
			const items = document.querySelectorAll('.rt_key');
	
			items.forEach(item => {
				const rtKeyValue = item.textContent.trim(); // rt_key の値を取得
	
				const matchedData = data.rt_bn_news_list.find(news => {
					return news._key === rtKeyValue; // JSON の _key と一致するかチェック
				});
	
				if (matchedData) {
					const tagElement = item
						.closest(".__item")
						.querySelector(".js-category");
					if (tagElement) {
						// cf_n_related_solutions 内の cf_nt_name_d を全て取得し、#で連結
						const relatedSolutions = matchedData.cf_n_related_solutions.map(
							(solution) => `${solution.cf_nt_name_d}`
						).join(" ");
						
						// タグ要素に設定
						tagElement.textContent = relatedSolutions;
					}
				}
			});
		};
	
		fetch(getJSONfiles())
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then(data => {
				insertTags(data);
			})
			.catch(error => {
				console.error('Error fetching JSON data:', error);
			});
	};

	const pickupCatInsert02 = () => {
		const getJSONfiles = () => '/ajax/news/list.json';
	
		const insertTags = (data) => {
			const items = document.querySelectorAll('.rt_key');
	
			items.forEach(item => {
				const rtKeyValue = item.textContent.trim(); // rt_key の値を取得
	
				const matchedData = data.rt_bn_news_list.find(news => {
					return news._key === rtKeyValue; // JSON の _key と一致するかチェック
				});
	
				if (matchedData) {
					const tagElement = item
						.closest(".__item")
						.querySelector(".js-pickup");
					if (tagElement) {
						tagElement.textContent = `${matchedData.cf_n_category.cf_nc_name}`;
					}
				}
			});
		};
	
		fetch(getJSONfiles())
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then(data => {
				insertTags(data);
			})
			.catch(error => {
				console.error('Error fetching JSON data:', error);
			});
	};

	
	dropDownAndTabs();
	pickupSlide();
	introductionSlide();
	pickupCatInsert();
	pickupCatInsert02();


})(window.FUNCTIONS);
